import { Box, Card, Grid, Tooltip, Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import React from "react";
import Chart from "react-apexcharts";
import InformationCircleIcon from "../../../icons/InformationCircle";
import { useTranslation } from "react-i18next";

const LineChart = () => {
  const theme = useTheme();
  const chart: any = {
    options: {
      chart: {
        background: "transparent",
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      colors: ["#ff7427"],
      dataLabels: {
        enabled: false,
      },
      grid: {
        show: false,
      },
      stroke: {
        width: 3,
      },
      theme: {
        mode: theme.palette.mode,
      },
      tooltip: {
        enabled: false,
      },
      xaxis: {
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        show: false,
      },
    },
    series: [
      {
        data: [0, 60, 30, 60, 0, 30, 10, 30, 0],
      },
    ],
  };

  return <Chart type="line" width={120} {...chart} />;
};

const PredictionGeneralOverview = ({
  averagePricePPPerStay,
  minimalPricePPPerStay,
  maximalPricePPPerStay,
}) => {
  const { t } = useTranslation();

  const currency =
    localStorage.getItem("currency") !== "undefined"
      ? localStorage.getItem("currency")
      : "PLN";
  return (
    <Grid container spacing={2}>
      <Grid item md={4} sm={6} xs={12}>
        <Card>
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              justifyContent: "space-between",
              p: 3,
            }}
          >
            <Box
              sx={{
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography color="textPrimary" variant="subtitle2">
                  {t("prediction.average_price")}
                </Typography>
                <Tooltip
                  title={t(`other.tooltip_prediction_go`)}
                  sx={{ ml: 1 }}
                >
                  <InformationCircleIcon fontSize="small" />
                </Tooltip>
              </Box>
              <Typography color="textPrimary" sx={{ mt: 1 }} variant="h4">
                {averagePricePPPerStay} {currency}
              </Typography>
            </Box>
            <LineChart />
          </Box>
        </Card>
      </Grid>
      <Grid item md={4} sm={6} xs={12}>
        <Card>
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              justifyContent: "space-between",
              p: 3,
            }}
          >
            <Box
              sx={{
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography color="textPrimary" variant="subtitle2">
                  {t("prediction.minimal_price")}
                </Typography>
              </Box>
              <Typography color="textPrimary" sx={{ mt: 1 }} variant="h4">
                {minimalPricePPPerStay} {currency}
              </Typography>
            </Box>
            <LineChart />
          </Box>
        </Card>
      </Grid>
      <Grid item md={4} sm={6} xs={12}>
        <Card>
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              justifyContent: "space-between",
              p: 3,
            }}
          >
            <Box
              sx={{
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography color="textPrimary" variant="subtitle2">
                  {t("prediction.maximal_price.")}
                </Typography>
              </Box>
              <Typography color="textPrimary" sx={{ mt: 1 }} variant="h4">
                {maximalPricePPPerStay} {currency}
              </Typography>
            </Box>
            <LineChart />
          </Box>
        </Card>
      </Grid>
      <Grid item md={3} sm={6} xs={12}></Grid>
    </Grid>
  );
};

export default PredictionGeneralOverview;
